import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackRouteChange } from '../services/datadog';

/**
 * A component that monitors route changes in React Router and reports them to Datadog
 * This component should be placed inside the router context
 */
const RouteChangeMonitor = () => {
  // This hook gives us access to the current location object
  const location = useLocation();

  // Track route changes when location changes
  useEffect(() => {
    try {
      // Extract the page name from the pathname
      const pathSegments = location.pathname.split('/').filter(Boolean);
      const pageName = pathSegments.length > 0 ? pathSegments.join('-') : 'dashboard';
      
      // Track the route change
      trackRouteChange(pageName);
      
      // We can also log it to confirm it's working
      console.log('Route change tracked:', pageName);
    } catch (err) {
      // Silently fail if there's an error
      console.error('Error tracking route change:', err);
    }
  }, [location]); // This effect runs whenever the location changes

  // Also keep the hashchange listener for non-React Router navigation
  useEffect(() => {
    // Function to handle direct hash changes (fallback)
    const handleHashChange = () => {
      try {
        const path = window.location.hash.replace('#', '').split('?')[0];
        const pathSegments = path.split('/').filter(Boolean);
        const pageName = pathSegments.length > 0 ? pathSegments.join('-') : 'dashboard';
        
        // Track the route change
        trackRouteChange(pageName);
      } catch (err) {
        // Silently fail if there's an error
        console.error('Error tracking hash change:', err);
      }
    };
    
    // Add event listener for hash changes as a fallback
    window.addEventListener('hashchange', handleHashChange);
    
    // Clean up
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);
  
  return null;
};

export default RouteChangeMonitor; 